import { Directive, HostListener, Output, EventEmitter, Input } from '@angular/core';

/**
 * Emette un booleano e un json indicando se il mouse è in hover su un elemento.
 * Utilizza EventEmitter per comunicare lo stato al componente padre.
 */
@Directive({
  selector: '[appHoverTooltip]'
})
export class HoverTooltipDirective {
  /* Dati in input da riemettere */
  @Input('appHoverTooltip') data: any;
  /** Emette `true` su mouseenter, `false` su mouseleave */
  @Output() isHovered: EventEmitter<boolean> = new EventEmitter<boolean>();
  /** Emette i dati su mouseenter, undefined su mouseleave */
  @Output() dataTooltip: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostListener('mouseenter', ['$event'])
  onMouseEnter(event: MouseEvent): void {
    this.isHovered.emit(true);
    this.dataTooltip.emit(this.data);
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent): void {
    this.isHovered.emit(false);
    this.dataTooltip.emit(undefined);
  }
}
